import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BookOpenIcon, CheckCircleIcon, PlayCircleIcon, ChevronDownIcon, ChevronUpIcon, VideoIcon, HelpCircleIcon, SparklesIcon, BellIcon, ArrowLeftIcon } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
import ReactPlayer from 'react-player';
export function Learning() {
  const location = useLocation();
  const navigate = useNavigate();
  const [expandedCourse, setExpandedCourse] = useState<string | null>(null);
  const [playingVideo, setPlayingVideo] = useState<string | null>(null);
  const [todayVideoExpanded, setTodayVideoExpanded] = useState(false);
  const [todayPlayingVideo, setTodayPlayingVideo] = useState<string | null>(null);
  const currentUser = {
    name: '妈妈，张春燕',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    points: 720
  };
  useEffect(() => {
    // 检查是否从首页的"开始学习"按钮跳转过来
    if (location.state?.autoPlay) {
      setTodayVideoExpanded(true);
      setTodayPlayingVideo(todayRecommendation.videos[0].id);
      // 清除state,避免刷新时重复触发
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  const todayRecommendation = {
    videos: [{
      id: 'today-v1',
      title: '0-6个月宝宝发展指南',
      duration: '2:49',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      description: '了解宝宝在这个阶段的关键发展里程碑',
      quizzes: [{
        id: 'tq1-1',
        question: '低月龄宝宝胀气是否是哭闹的原因之一?',
        options: ['是', '否', '不确定']
      }, {
        id: 'tq1-2',
        question: '宝宝每天需要多少小时的睡眠?',
        options: ['12-14小时', '14-17小时', '18-20小时']
      }]
    }, {
      id: 'today-v2',
      title: '半岁宝宝发展',
      duration: '4:32',
      url: 'https://www.youtube.com/watch?v=4otE7HxWKJg',
      description: '6个月宝宝的重要发展阶段',
      quizzes: [{
        id: 'tq2-1',
        question: '6个月宝宝可以开始添加辅食了吗?',
        options: ['可以', '不可以', '需要医生建议']
      }, {
        id: 'tq2-2',
        question: '宝宝翻身是正常的发展里程碑吗?',
        options: ['是', '否', '因人而异']
      }]
    }, {
      id: 'today-v3',
      title: '一岁宝宝发展',
      duration: '4:45',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      description: '一岁宝宝的成长关键点',
      quizzes: [{
        id: 'tq3-1',
        question: '1岁宝宝应该会说几个词?',
        options: ['1-3个', '5-10个', '10个以上']
      }, {
        id: 'tq3-2',
        question: '宝宝开始走路是在什么时候?',
        options: ['9-12个月', '12-15个月', '15-18个月']
      }]
    }, {
      id: 'today-v4',
      title: '宝宝语言发展',
      duration: '5:20',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      description: '促进宝宝语言能力的有效方法',
      quizzes: [{
        id: 'tq4-1',
        question: '和宝宝多说话有助于语言发展吗?',
        options: ['有', '没有', '不确定']
      }, {
        id: 'tq4-2',
        question: '宝宝什么时候开始说第一个词?',
        options: ['6-9个月', '9-12个月', '12-18个月']
      }]
    }, {
      id: 'today-v5',
      title: '宝宝运动能力培养',
      duration: '6:15',
      url: 'https://www.youtube.com/watch?v=kc7nN-r5y2I',
      description: '帮助宝宝发展大运动技能',
      quizzes: [{
        id: 'tq5-1',
        question: '爬行对宝宝发展重要吗?',
        options: ['重要', '不重要', '可有可无']
      }, {
        id: 'tq5-2',
        question: '应该让宝宝多趴着玩吗?',
        options: ['应该', '不应该', '看情况']
      }]
    }]
  };
  const courses = [{
    id: 'course-1',
    title: '0-6个月宝宝发展',
    progress: 60,
    lessons: 12,
    completed: 7,
    color: 'from-blue-500 to-cyan-500',
    videos: [{
      id: 'v1',
      title: '0-6个月宝宝发展',
      duration: '2:49',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q1-1',
        question: '低月龄宝宝胀气是否是哭闹的原因之一?',
        options: ['是', '否', '不确定']
      }, {
        id: 'q1-2',
        question: '宝宝每天需要多少小时的睡眠?',
        options: ['12-14小时', '14-17小时', '18-20小时']
      }]
    }, {
      id: 'v2',
      title: '半岁宝宝发展',
      duration: '4:32',
      url: 'https://www.youtube.com/watch?v=4otE7HxWKJg',
      quizzes: [{
        id: 'q2-1',
        question: '6个月宝宝可以开始添加辅食了吗?',
        options: ['可以', '不可以', '需要医生建议']
      }, {
        id: 'q2-2',
        question: '宝宝翻身是正常的发展里程碑吗?',
        options: ['是', '否', '因人而异']
      }]
    }, {
      id: 'v3',
      title: '一岁宝宝发展',
      duration: '4:45',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q3-1',
        question: '1岁宝宝应该会说几个词?',
        options: ['1-3个', '5-10个', '10个以上']
      }, {
        id: 'q3-2',
        question: '宝宝开始走路是在什么时候?',
        options: ['9-12个月', '12-15个月', '15-18个月']
      }]
    }]
  }, {
    id: 'course-2',
    title: '营养与喂养基础',
    progress: 30,
    lessons: 10,
    completed: 3,
    color: 'from-green-500 to-emerald-500',
    videos: [{
      id: 'v4',
      title: '母乳喂养指南',
      duration: '4:15',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q4-1',
        question: '母乳喂养的最佳频率是?',
        options: ['按需喂养', '每3小时', '每4小时']
      }, {
        id: 'q4-2',
        question: '母乳喂养需要额外补充水分吗?',
        options: ['需要', '不需要', '看情况']
      }]
    }, {
      id: 'v5',
      title: '辅食添加技巧',
      duration: '3:28',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q5-1',
        question: '第一次添加辅食应该选择?',
        options: ['米粉', '蔬菜泥', '水果泥']
      }, {
        id: 'q5-2',
        question: '辅食添加应该遵循什么原则?',
        options: ['由少到多', '由稀到稠', '以上都是']
      }]
    }, {
      id: 'v6',
      title: '营养均衡搭配',
      duration: '4:20',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q6-1',
        question: '宝宝每天需要摄入多少蛋白质?',
        options: ['10-15克', '15-20克', '20-25克']
      }, {
        id: 'q6-2',
        question: '哪些食物富含铁元素?',
        options: ['红肉', '绿叶蔬菜', '以上都是']
      }]
    }]
  }, {
    id: 'course-3',
    title: '日常护理技巧',
    progress: 80,
    lessons: 8,
    completed: 6,
    color: 'from-purple-500 to-pink-500',
    videos: [{
      id: 'v7',
      title: '洗澡护理步骤',
      duration: '3:45',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q7-1',
        question: '宝宝洗澡水温应该是多少?',
        options: ['35-37℃', '38-40℃', '40-42℃']
      }, {
        id: 'q7-2',
        question: '新生儿每天需要洗澡吗?',
        options: ['需要', '不需要', '看情况']
      }]
    }, {
      id: 'v8',
      title: '睡眠习惯培养',
      duration: '4:55',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q8-1',
        question: '建立睡眠规律的最佳时间是?',
        options: ['出生后', '3个月后', '6个月后']
      }, {
        id: 'q8-2',
        question: '宝宝夜醒是正常的吗?',
        options: ['是', '否', '因年龄而异']
      }]
    }, {
      id: 'v9',
      title: '日常安全注意',
      duration: '3:30',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q9-1',
        question: '宝宝独自在床上时需要注意什么?',
        options: ['防止跌落', '避免窒息', '以上都是']
      }, {
        id: 'q9-2',
        question: '家中哪些物品需要特别注意?',
        options: ['小物件', '清洁剂', '以上都是']
      }]
    }]
  }, {
    id: 'course-4',
    title: '儿童认知发展',
    progress: 15,
    lessons: 9,
    completed: 1,
    color: 'from-orange-500 to-red-500',
    videos: [{
      id: 'v10',
      title: '认知发展阶段',
      duration: '5:10',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q10-1',
        question: '皮亚杰理论中,感知运动阶段是在什么年龄?',
        options: ['0-2岁', '2-7岁', '7-11岁']
      }, {
        id: 'q10-2',
        question: '物体恒存概念通常在几个月建立?',
        options: ['4-6个月', '8-12个月', '12-18个月']
      }]
    }, {
      id: 'v11',
      title: '记忆力培养',
      duration: '4:25',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q11-1',
        question: '重复和规律对儿童记忆有帮助吗?',
        options: ['有', '没有', '因人而异']
      }, {
        id: 'q11-2',
        question: '游戏化学习能提升记忆效果吗?',
        options: ['能', '不能', '不确定']
      }]
    }, {
      id: 'v12',
      title: '注意力训练',
      duration: '3:55',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q12-1',
        question: '3岁儿童的注意力集中时间约为?',
        options: ['5-10分钟', '10-15分钟', '15-20分钟']
      }, {
        id: 'q12-2',
        question: '环境干扰会影响儿童注意力吗?',
        options: ['会', '不会', '看情况']
      }]
    }]
  }, {
    id: 'course-5',
    title: '社交情感培养',
    progress: 40,
    lessons: 11,
    completed: 4,
    color: 'from-rose-500 to-pink-600',
    videos: [{
      id: 'v13',
      title: '情绪认知与表达',
      duration: '4:40',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q13-1',
        question: '儿童几岁开始能识别基本情绪?',
        options: ['1-2岁', '2-3岁', '3-4岁']
      }, {
        id: 'q13-2',
        question: '家长应该压制孩子的负面情绪吗?',
        options: ['应该', '不应该', '看情况']
      }]
    }, {
      id: 'v14',
      title: '同伴关系建立',
      duration: '5:15',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q14-1',
        question: '平行游戏通常出现在什么年龄?',
        options: ['1-2岁', '2-3岁', '3-4岁']
      }, {
        id: 'q14-2',
        question: '分享意识的培养需要强制吗?',
        options: ['需要', '不需要', '适度引导']
      }]
    }, {
      id: 'v15',
      title: '共情能力培养',
      duration: '4:05',
      url: 'https://youtu.be/P4VVsAvZKtw',
      quizzes: [{
        id: 'q15-1',
        question: '共情能力可以通过后天培养吗?',
        options: ['可以', '不可以', '部分可以']
      }, {
        id: 'q15-2',
        question: '绘本阅读有助于培养共情能力吗?',
        options: ['有', '没有', '不确定']
      }]
    }]
  }];
  const toggleCourse = (courseId: string) => {
    if (expandedCourse === courseId) {
      setExpandedCourse(null);
      setPlayingVideo(null);
    } else {
      setExpandedCourse(courseId);
      const course = courses.find(c => c.id === courseId);
      if (course && course.videos.length > 0) {
        setPlayingVideo(course.videos[0].id);
      }
    }
  };
  const toggleVideo = (videoId: string) => {
    setPlayingVideo(videoId);
  };
  const toggleTodayVideo = (videoId: string) => {
    setTodayVideoExpanded(true);
    setTodayPlayingVideo(videoId);
  };
  const handleBackClick = () => {
    // 如果今日推荐视频正在播放，先关闭它
    if (todayPlayingVideo) {
      setTodayPlayingVideo(null);
      setTodayVideoExpanded(false);
      return;
    }
    // 如果课程视频正在播放，先关闭它
    if (playingVideo) {
      setPlayingVideo(null);
      setExpandedCourse(null);
      return;
    }
    // 否则返回上一页
    navigate(-1);
  };
  return <div className="min-h-screen bg-gradient-to-b from-purple-50 to-blue-50 pb-16" data-id="element-310">
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-311">
        <div className="px-4 py-3 flex items-center justify-center relative" data-id="element-312">
          <button onClick={handleBackClick} className={"absolute left-4 transition-colors"} data-id="element-313">
            <ArrowLeftIcon size={20} className="mb-1" data-id="element-314" />
            <span className="text-xs font-medium" data-id="element-315">返回</span>
          </button>
          <h1 className="text-2xl font-bold text-amber-700" data-id="element-316">Everseed</h1>
          <div className="flex items-center space-x-3 absolute right-4" data-id="element-317">
            <Link to="/notifications" className="relative" data-id="element-318">
              <BellIcon size={24} className="text-gray-600" data-id="element-319" />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold" data-id="element-320">
                3
              </span>
            </Link>
            <img src={currentUser.avatar} alt={currentUser.name} className="w-9 h-9 rounded-full object-cover border-2 border-indigo-200" data-id="element-321" />
          </div>
        </div>
      </header>
      <main className="px-4 py-4" data-id="element-322">
        <div className="mb-6" data-id="element-323">
          <div className="flex items-center mb-2 px-1" data-id="element-324">
            <SparklesIcon size={20} className="text-indigo-600 mr-2" data-id="element-325" />
            <h2 className="text-lg font-bold text-gray-800" data-id="element-326">今日推荐课程</h2>
          </div>
          {!todayVideoExpanded ? <div className="bg-white rounded-xl overflow-hidden shadow-lg cursor-pointer" onClick={() => toggleTodayVideo(todayRecommendation.videos[0].id)} data-id="element-327">
              <div className="relative aspect-video" data-id="element-328">
                <ReactPlayer url={todayRecommendation.videos[0].url} width="100%" height="100%" controls={false} light playing={false} data-id="element-329" />
              </div>
              <div className="p-3" data-id="element-330">
                <h3 className="font-bold text-gray-800 mb-1" data-id="element-331">
                  {todayRecommendation.videos[0].title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-332">
                  {todayRecommendation.videos[0].description}
                </p>
              </div>
            </div> : <div className="space-y-4" data-id="element-333">
              {todayRecommendation.videos.map((video, index) => {
            const isPlaying = todayPlayingVideo === video.id;
            const nextVideos = todayRecommendation.videos.slice(index + 1);
            if (isPlaying) {
              return <div key={video.id} data-id="element-334">
                      <div className="bg-white rounded-xl overflow-hidden shadow-lg mb-4" data-id="element-335">
                        <div className="relative aspect-video" data-id="element-336">
                          <ReactPlayer url={video.url} width="100%" height="100%" controls light playing={false} data-id="element-337" />
                        </div>
                        <div className="p-3" data-id="element-338">
                          <h4 className="font-semibold text-gray-800" data-id="element-339">
                            {video.title}
                          </h4>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-340">
                            {video.duration}
                          </p>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-341">
                        <div className="flex items-center mb-3" data-id="element-342">
                          <HelpCircleIcon size={18} className="text-indigo-600 mr-2" data-id="element-343" />
                          <h5 className="text-sm font-semibold text-gray-700" data-id="element-344">
                            小测验
                          </h5>
                        </div>
                        <p className="text-xs text-gray-500 mb-3" data-id="element-345">
                          观看后将测试以下内容:
                        </p>
                        <div className="space-y-2" data-id="element-346">
                          {video.quizzes.map((quiz, idx) => <div key={quiz.id} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-347">
                              <span className="text-indigo-600 font-medium" data-id="element-348">
                                {idx + 1}.
                              </span>
                              <span data-id="element-349">{quiz.question}</span>
                            </div>)}
                        </div>
                      </div>
                      {nextVideos.length > 0 && <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-350">
                          <h5 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-351">
                            接下来的视频
                          </h5>
                          <div className="space-y-2" data-id="element-352">
                            {nextVideos.map((nextVideo, idx) => <div key={nextVideo.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 active:bg-gray-200 transition-colors" onClick={() => toggleTodayVideo(nextVideo.id)} data-id="element-353">
                                <div className="flex items-center gap-3 flex-1" data-id="element-354">
                                  <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 text-xs font-semibold" data-id="element-355">
                                    {index + idx + 2}
                                  </div>
                                  <div className="flex-1" data-id="element-356">
                                    <p className="text-sm font-medium text-gray-800" data-id="element-357">
                                      {nextVideo.title}
                                    </p>
                                    <p className="text-xs text-gray-500" data-id="element-358">
                                      {nextVideo.duration}
                                    </p>
                                  </div>
                                </div>
                                <PlayCircleIcon size={20} className="text-indigo-600" data-id="element-359" />
                              </div>)}
                          </div>
                        </div>}
                    </div>;
            }
            return null;
          })}
            </div>}
        </div>
        <div className="mb-3" data-id="element-360">
          <h2 className="text-lg font-bold text-gray-700" data-id="element-361">全部课程</h2>
        </div>
        <div className="grid gap-4" data-id="element-362">
          {courses.map(course => <div key={course.id} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-363">
              <div className={`bg-gradient-to-r ${course.color} p-4 text-white cursor-pointer active:scale-[0.99] transition-transform`} onClick={() => toggleCourse(course.id)} data-id="element-364">
                <div className="flex items-center justify-between" data-id="element-365">
                  <div className="flex-1" data-id="element-366">
                    <h3 className="text-lg font-bold" data-id="element-367">{course.title}</h3>
                  </div>
                  <div className="flex items-center gap-3 ml-4" data-id="element-368">
                    <div className="text-right" data-id="element-369">
                      <div className="text-2xl font-bold" data-id="element-370">
                        {course.progress}%
                      </div>
                      <div className="text-xs opacity-80" data-id="element-371">
                        {course.completed}/{course.lessons}
                      </div>
                    </div>
                    {expandedCourse === course.id ? <ChevronUpIcon size={24} data-id="element-372" /> : <ChevronDownIcon size={24} data-id="element-373" />}
                  </div>
                </div>
                <div className="mt-3" data-id="element-374">
                  <div className="w-full bg-white bg-opacity-20 rounded-full h-1.5" data-id="element-375">
                    <div className="bg-white h-1.5 rounded-full transition-all" style={{
                  width: `${course.progress}%`
                }} data-id="element-376"></div>
                  </div>
                </div>
              </div>
              {expandedCourse === course.id && <div className="bg-gray-50 px-4 py-6" data-id="element-377">
                  <div className="relative" data-id="element-378">
                    {course.videos.map((video, index) => {
                const isPlaying = playingVideo === video.id;
                const nextVideos = course.videos.slice(index + 1);
                return <div key={video.id} className="relative" data-id="element-379">
                          <div className="flex gap-4" data-id="element-380">
                            <div className="flex flex-col items-center" data-id="element-381">
                              <div className="text-amber-500 font-bold text-base z-10" data-id="element-382">
                                {index + 1}
                              </div>
                              {index < course.videos.length - 1 && <div className="w-0.5 h-full bg-amber-400 mt-2" data-id="element-383"></div>}
                            </div>
                            <div className="flex-1 pb-8" data-id="element-384">
                              {isPlaying ? <div data-id="element-385">
                                  <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-386">
                                    <div className="relative aspect-video" data-id="element-387">
                                      <ReactPlayer url={video.url} width="100%" height="100%" controls light playing={false} data-id="element-388" />
                                    </div>
                                    <div className="p-3" data-id="element-389">
                                      <h4 className="font-semibold text-gray-800" data-id="element-390">
                                        {video.title}
                                      </h4>
                                      <p className="text-xs text-gray-500 mt-1" data-id="element-391">
                                        {video.duration}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="bg-white rounded-lg p-4 shadow-sm mb-4" data-id="element-392">
                                    <div className="flex items-center mb-3" data-id="element-393">
                                      <HelpCircleIcon size={18} className="text-indigo-600 mr-2" data-id="element-394" />
                                      <h5 className="text-sm font-semibold text-gray-700" data-id="element-395">
                                        小测验
                                      </h5>
                                    </div>
                                    <p className="text-xs text-gray-500 mb-3" data-id="element-396">
                                      观看后将测试以下内容:
                                    </p>
                                    <div className="space-y-2" data-id="element-397">
                                      {video.quizzes.map((quiz, idx) => <div key={quiz.id} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-398">
                                          <span className="text-indigo-600 font-medium" data-id="element-399">
                                            {idx + 1}.
                                          </span>
                                          <span data-id="element-400">{quiz.question}</span>
                                        </div>)}
                                    </div>
                                  </div>
                                  {nextVideos.length > 0 && <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-401">
                                      <h5 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-402">
                                        接下来的视频
                                      </h5>
                                      <div className="space-y-2" data-id="element-403">
                                        {nextVideos.map((nextVideo, idx) => <div key={nextVideo.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 active:bg-gray-200 transition-colors" onClick={() => toggleVideo(nextVideo.id)} data-id="element-404">
                                            <div className="flex items-center gap-3 flex-1" data-id="element-405">
                                              <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 text-xs font-semibold" data-id="element-406">
                                                {index + idx + 2}
                                              </div>
                                              <div className="flex-1" data-id="element-407">
                                                <p className="text-sm font-medium text-gray-800" data-id="element-408">
                                                  {nextVideo.title}
                                                </p>
                                                <p className="text-xs text-gray-500" data-id="element-409">
                                                  {nextVideo.duration}
                                                </p>
                                              </div>
                                            </div>
                                            <PlayCircleIcon size={20} className="text-indigo-600" data-id="element-410" />
                                          </div>)}
                                      </div>
                                    </div>}
                                </div> : <div className="bg-white rounded-lg p-4 cursor-pointer hover:bg-gray-50 active:bg-gray-100 transition-colors shadow-sm" onClick={() => toggleVideo(video.id)} data-id="element-411">
                                  <div className="flex items-center justify-between" data-id="element-412">
                                    <div className="flex-1" data-id="element-413">
                                      <p className="text-sm font-medium text-gray-800" data-id="element-414">
                                        {video.title}
                                      </p>
                                      <p className="text-xs text-gray-500 mt-1" data-id="element-415">
                                        {video.duration}
                                      </p>
                                    </div>
                                    <PlayCircleIcon size={24} className="text-indigo-600 ml-3" data-id="element-416" />
                                  </div>
                                </div>}
                            </div>
                          </div>
                        </div>;
              })}
                  </div>
                </div>}
            </div>)}
        </div>
      </main>
      <BottomNav onBackClick={handleBackClick} data-id="element-417" />
    </div>;
}